import { Site } from '@envato/foundation-types'

import * as classnames from 'classnames'
import * as React from 'react'

import CartIcon from '../../../components/icons/cart'
import Button from '../../buttons/button'
import { IItemCard } from '../interface'

import { ICommonLocation } from '../../../../common/utils/location/types'
import { IExperimentsState } from '../../../../common/reducers/experiments'
import { hasFeature } from '../../../../common/utils/features'

import * as styles from './lockupAddToCartButton.module.css'

interface IProps extends IItemCard {
  icon?: boolean
  currentSite: Site
  experiments: IExperimentsState
  location: ICommonLocation
}

const LockupAddToCartButton = ({
  item,
  onAddToCart,
  icon,
  currentSite,
  experiments,
  location
}: IProps) => {
  const inverted = hasFeature(
    'invertedAddToCartButton',
    currentSite,
    location,
    experiments
  )
  const invertedWithPlus = hasFeature(
    'invertedAddToCartButtonWithPlus',
    currentSite,
    location,
    experiments
  )
  const altPrimary = !inverted && !invertedWithPlus

  const classNames = classnames(styles.root, { [styles.fullWidth]: !icon })

  const getCart = () => {
    return invertedWithPlus ? (
      <React.Fragment>
        +<CartIcon />
      </React.Fragment>
    ) : (
      <CartIcon />
    )
  }

  return (
    <Button
      role="button"
      altPrimary={altPrimary}
      inverted={inverted}
      invertedWithPlus={invertedWithPlus}
      href={`/cart/configure_before_adding/${item.id}`}
      onClick={onAddToCart}
      active={item.ui.isInCart}
      className={classNames}
      target="_blank"
      rel="noopener noreferrer"
    >
      {icon ? getCart() : 'Add to Cart'}
    </Button>
  )
}

export default LockupAddToCartButton
